import axios from "../../../config/axiosConfig";

export const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

// Lee una lista venga como [...], { data: [...] } o { data: { data: [...] } } (según el endpoint).
const lista = (body) => {
  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.data?.data)) return body.data.data;
  return [];
};

export const buscarPresupuestos = async (anio, extra = {}) => {
  const { data } = await axios.get("/api/presupuestos/search", { params: { anio, limit: 10000, orderDir: "ASC", ...extra } });
  return lista(data);
};
export const crearPresupuesto = (body) => axios.post("/api/presupuestos", body);
export const actualizarPresupuesto = (id, body) => axios.put(`/api/presupuestos/${encodeURIComponent(id)}`, body);
export const eliminarPresupuesto = (id) => axios.delete(`/api/presupuestos/${encodeURIComponent(id)}`);
export const importarPresupuestosLote = (filas) => axios.post("/api/presupuestos/bulk", filas);

export const resumenPresupuestoMacrocuenta = async (anio) => lista((await axios.get("/api/presupuestos/resumen/macrocuenta", { params: { anio } })).data);
export const ejecutadoAnualMacrocuenta = async (anio) => lista((await axios.get("/api/reporte-macrocuenta/anual", { params: { anio } })).data);
export const egresosDeMacrocuentaMes = async (idMacrocuenta, anio, mesNum) =>
  lista((await axios.get("/api/egresos", { params: { id_macrocuenta: idMacrocuenta, anio, mesNum, anulado: "no" } })).data);

export const num = (v) => {
  const n = Number(String(v ?? "").replace(/,/g, ""));
  return Number.isFinite(n) ? n : 0;
};
export const fmt = (v) => num(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
